import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=3aefbfea&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aefbfea",
  null
  
)

export default component.exports